// Modern Clean Brand Colors - Subtle & Refined
export const BRAND_COLORS = {
  primary: "#339274",          // Primary Green
  primaryHover: "#29795f",     // Darker Green for hover
  primaryLight: "#F8FCFA",     // Very subtle green background
  primarySoft: "#EDF7F2",      // Soft green background
  primaryBorder: "#D1E7DD",    // Light green border
  accent: "#A3CD39",           // Lime accent
  accentLight: "#F7FAF0",      // Light lime background
  dark: "#007F66",             // Deep teal
  neutral: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F3F4F6", 
    200: "#E5E7EB",
    300: "#D1D5DB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
    700: "#374151",
    800: "#1F2937",
    900: "#111827"
  },
  success: "#10B981",
  successLight: "#F0FDF4",
  error: "#EF4444", 
  errorLight: "#FEF2F2",
  warning: "#F59E0B",
  warningLight: "#FFFBEB",
};
